export function renderTextOverlay(pos, txt, map, style) {
  class TextOverlay extends window.google.maps.OverlayView {
    constructor(pos, txt, map) {
      super();
      this.pos = pos;
      this.txt = txt;
      this.map = map;
      this.div = null;
      this.style = style;
      this.setMap(map);
    }
    onAdd() {
      let div = document.createElement("div");
      div.style.position = "absolute";
      div.style.whiteSpace = "nowrap";
      div.style.backgroundColor = "inherit";
      div.style.color = "black";
      div.style.fontSize = "12px";
      div.style.fontWeight = "bold";
      div.style.width = "44px";
      div.style.height = "24px";
      div.innerText = this.txt;
      Object.keys(this.style).forEach((key) => {
        div.style[key] = this.style[key];
      });
      this.div = div;

      let panes = this.getPanes();
      panes.floatPane.appendChild(div);
    }

    draw() {
      let overlayProjection = this.getProjection();

      let position = overlayProjection.fromLatLngToDivPixel(this.pos);

      let div = this.div;
      div.style.left = position.x - 22 + "px";
      div.style.top = position.y - 12 + "px";
    }

    onRemove() {
      if (this.div) {
        this.div.parentNode.removeChild(this.div);
        this.div = null;
      }
    }
  }
  return new TextOverlay(pos, txt, map, style);
}

function getAttributeValue(id, attributes) {
  switch (id) {
    case "avg_hh_value":
      return parseInt(attributes["dw_value"] / attributes["total_households"]);
    case "dw_rented":
      return parseInt(attributes["total_households"] - attributes["owned"]);
    case "semi_duplex":
      return parseInt(attributes["semi"] + attributes["duplex"]);
    case "apt":
      return parseInt(attributes["apt5"] + attributes["apt5_"]);
    case "remaining":
      return parseInt(
        attributes["total_households"] -
          attributes["row"] -
          attributes["single"] -
          attributes["semi"] -
          attributes["duplex"] -
          attributes["apt5"] -
          attributes["apt5_"]
      );
    case "hh_tot":
    case "pop_tot":
    case "adult_pop":
    case "hbc_tot_wc":
    case "tot_exp_wc":
    case "hbc_tot_mc":
    case "tot_exp_mc":
    case "hbc_tot_mw":
    case "tot_exp_cl":
    case "hbc_clsow_":
    case "hbc_visit_":
    case "hbc_cust_t":
    case "hbc_sales_":
    case "hbc_spend_":
    case "hbc_inc_sa":
    case "hbc_pot_pe":
      return parseInt(attributes?.hbc_data?.[id], 10);
    default:
      return attributes[id];
  }
}

function getDisplayValue(item, value) {
  switch (item.unit) {
    case "$":
      return "$ " + value?.toLocaleString();
    default:
      return value?.toLocaleString();
  }
}

function addPercentIfRequired(i, data) {
  switch (i.id) {
    case "age4":
    case "age9":
    case "age14":
    case "age19":
    case "age24":
    case "age29":
    case "age34":
    case "age39":
    case "age44":
    case "age49":
    case "age54":
    case "age59":
    case "age64":
    case "age69":
    case "age74":
    case "age79":
    case "age84":
    case "age85":
      return parseInt((data[i.id] / data["pp_total"]) * 100);

    case "owned":
    case "dw_rented":
      return parseInt(
        (getAttributeValue(i.id, data) / data["total_households"]) * 100
      );
    default:
      return null;
  }
}

export function getAttributeRow(i, data) {
  const value = getAttributeValue(i.id, data);
  return {
    ...i,
    value,
    displayValue: getDisplayValue(i, value),
    percentage: addPercentIfRequired(i, data),
  };
}
